import { organizationSelectedSelector } from "reduxStore/organization/selectors";
import { useAppSelector } from "./useAppSelector";
import { useMemo } from "react";
import { ORG_TYPE, Organization } from "types/organization";
import { useParams } from "react-router-dom";

export const useClinicText = (
  isMenu: boolean = false,
  org: Organization | null = null,
) => {
  const organizationSelected = useAppSelector(organizationSelectedSelector);
  const { organizationId } = useParams();
  const organization = useMemo(
    () => organizationSelected || org,
    [organizationSelected, org],
  );

  const textYearlyCurriculum = useMemo(() => {
    return "Program";
  }, [organization, organizationId]);

  const textAcademicYear = useMemo(() => {
    return "Program";
  }, [organization, organizationId]);

  const textGraduationClass = useMemo(() => {
    return organization?.type === ORG_TYPE.CLINIC && (organizationId || isMenu)
      ? "Cohort"
      : "Graduation Class";
  }, [organization, organizationId]);

  const textGraduationClasses = useMemo(() => {
    return organization?.type === ORG_TYPE.CLINIC && (organizationId || isMenu)
      ? "Cohorts"
      : "Graduation Classes";
  }, [organization, organizationId]);

  return {
    textYearlyCurriculum,
    textAcademicYear,
    textGraduationClass,
    textGraduationClasses,
  };
};
